import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import useAuthToken from "../../Hooks/useAuthToken";

import { apiRequest } from "../../store/api/api";

function DepartmentList({ onEdit }) {
  const token = useAuthToken();
  const {
    data: allDepartment,
    isLoading: isSectionLoading,
    error: sectionError,
  } = useQuery({
    queryKey: ["department"],
    queryFn: () => apiRequest("get", "/api/team/department", null, token),
  });

  const data = allDepartment?.allDepartment
    ?.map((data, index) => ({
      index: index + 1,
      title: data?.title,
      actionButton: (
        <>
          <button
            onClick={() => onEdit(data)}
            className="btn text-success mx-2"
          >
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Title",
      accessor: "title",
    },

    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isSectionLoading} />
    </div>
  );
}

export default DepartmentList;
